import { OwnAdministrativeFeeDetailDto } from './ownadministrativefeedetaildto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class OwnAdministrativeFeeDetailRequest {

    OwnAdministrativeFeeDetailDto: OwnAdministrativeFeeDetailDto = new OwnAdministrativeFeeDetailDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}